import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UpaegService } from '../../services/upaeg.service';
import { SolicitudesService } from '../../services/solicitudes.service';
import { CombosService } from '../../services/combos.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmPopComponent} from '../confirm-pop/confirm-pop.component';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import {CurpValidator, RfcValidator, NameValidator, CPValidator, MovilValidator} from '../../validators/validator';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';
import { GLOBAL } from '../../services/global';
import { MouseEvent, GoogleMapsAPIWrapper, GoogleMapsScriptProtocol } from '@agm/core';
import { each } from 'jquery';
declare const google: any;

import {environment} from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { VincularDocumentoExpedienteComponent } from '../vincular-documento-expediente/vincular-documento-expediente.component';
declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-presolicitud',
  templateUrl: './presolicitud.component.html',
  styleUrls: ['./presolicitud.component.css'],
  providers: [UserService, UpaegService, SolicitudesService, CombosService]
})
export class PresolicitudComponent implements OnInit, OnDestroy{
  public idProductor;
  public ejercicio;
  public programa;
  public subprograma;
  public concepto;
  public upaeg;
  public mensaje;
  public haveApoyoSelected = false;
  public canVinculateDocto = false;
  public tieneValidaciones = false;

  public haveEncuesta = false;
  public encuestaName = 'Encuestas';
  public encuestaTitle = 'Encuesta';
  public encuestaInstrucciones = '';
  public preguntas = [];
  preguntasArr: FormArray;
  formEncuesta: FormGroup;
  multipleControl: FormArray;
  formEncuestasValid = false;
  encuestaRespondida = false;

  lat = 20.5279613;
  lng = -100.8112891;
  zoom = 18;
  public marcador: marker;
  markers: marker[] = [];
  public mapa = null;

  public fileText;

  formDoctos: FormGroup;
  form: FormGroup;
  formValidacion: FormGroup;
  forSisProd: FormGroup;
  formAddConceptoApoyo: FormGroup;


  public requisitos;
  public documentos;
  public tiposApoyos;
  public perfilesProyecto;
  public experiencias;
  public acreditaciones;

  public estados = [];
  public municipios = [];
  public localidades = [];
  public sistemsProdSolicitud = null;

  public asentamientos = [];
  public vialidades = [];


  public tiposSistemaProd = [];
  public sistemasProdu = [];




  public puedeRegistrar;

  public documentosEnalzados;

  public url;

  public isNew;
  public idProducer;
  public idPresol;

  public tabIndex;
  public presolStatus;
  public apoyosSolicitud;

  public tuvoApoyo = false;
  apios: FormArray;



  public canEdit = true;
  public canSend = false;
  public obsEdit = [];
  public obsSend = [];

  public tieneProyecto = false;

  public beneficiarios;
  beneficiariosArr: FormArray;

  totalBeneficiarios: number = 0;
  subscriptionBeneficiarios: Subscription;


  subprogramaMultiApoyo = false;
  apoyos_disponibles = [];
  apoyos_agregados = [];
  apoyos_agregado_helper = [];
  apoyos_disponibles_list = [];




  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private upaegService : UpaegService,
    private solicitudesService: SolicitudesService,
    public comboService: CombosService,
    public dialog: MatDialog,
    private fb: FormBuilder
  ){
    this.documentosEnalzados = null;
    this.url = GLOBAL.url;
    this.mensaje = 'Cargando información de la unidad de producción...';
    this.formDoctos = this.fb.group({
      idProductor: ['', [Validators.required]],
      idPresol: ['', []],
      ejercicio: ['', [Validators.required]],
      idPrograma: ['', [Validators.required]],
      idSubprograma: ['', [Validators.required]],
      idConceptoDeApoyo: ['', [Validators.required]],
      idRequisito: ['', [Validators.required]],
      idDocumento: ['', [Validators.required]],
      file: ['', [Validators.required]],
      helperfile: ['', []]
    });
    // new FormControl({value: 'Nancy', disabled: true}, Validators.required)
    this.form = this.fb.group({
      idProductor: ['', [Validators.required]],
      idPresol: ['', []],
      ejercicio: ['', [Validators.required]],
      empDirectosH: ['', [Validators.required]],
      empDirectosM: ['', [Validators.required]],
      empEventH: ['', [Validators.required]],
      empEventM: ['', [Validators.required]],
      empIndirectos: ['', [Validators.required]],
      isMigrante: [false, [Validators.required]],
      isJefeDeFamilia: [false, [Validators.required]],
      haveApoyo: [false, [Validators.required]],
      ejercicioRecivido:  new FormControl({value: null, disabled: true}, [Validators.required]),
      programaRecivido: new FormControl({value: null, disabled: true}, [Validators.required]),
      conceptoRecivido: new FormControl({value: null, disabled: true}, [Validators.required]),
      nombreProyecto: ['', [Validators.required]],
      descProyecto: ['', [Validators.required]],
      actividadPrincipal: ['', [Validators.required]],
      havInfraestructura: ['f', [Validators.required]],
      idPerfilProyecto: ['', [Validators.required]],
      idTipoProyecto: ['', [Validators.required]],
      idExperiencia: ['', [Validators.required]],
      idAcreditacionInfraestructura: ['', [Validators.required]],
      montoTotalDelProyecto: ['', [Validators.required]],
      idEdoProyecto: ['', [Validators.required]],
      idMunProyecto: ['', [Validators.required]],
      idLocProyecto: ['', [Validators.required]],
      idTipoAcentamientoProyecto: ['', [Validators.required]],
      nombreAcentamientoProyecto: ['', [Validators.required]],
      idTipoVialidadProyecto: ['', [Validators.required]],
      nombreVialidadProyecto: ['', [Validators.required]],
      noExterior: ['', [Validators.required]],
      noInterior: ['', []],
      codigoPostal: ['', [Validators.required]],
      telefonoDeContacto: ['', [Validators.required]],
      latitudProyecto: ['', [Validators.required]],
      longituProyecto: ['', [Validators.required]],
      obserbacionesSolicitud: ['', []],
      apoios: this.fb.array([], [Validators.required]),
      buscando: ['', []],
      idTipoSistemaProd: [null, []],
      idSistemProd: [null, []],
      notEmail: [false, [Validators.required]],
      emailNvo: [{value: '', disabled: true}, []],
      updateEmailUpaeg: [{value: false, disabled: true}, [Validators.required]],
      beneficiarios: this.fb.array([]),
    });
    this.formValidacion = this.fb.group({
      idPresol: ['', [Validators.required]],
      ejercicio: ['', [Validators.required]],
      obserbacionesSolicitud: ['', []],
    });

    this.forSisProd = this.fb.group({
      idTipoSistemaProd: [null, [Validators.required]],
      idSistemProd: [null, [Validators.required]]
    });

    this.formAddConceptoApoyo = this.fb.group({
      concepto_apoyo: ['',null],
    });
    this.tabIndex = 0;
    this.presolStatus = false;
    this.apoyosSolicitud = null;
    this.tuvoApoyo = true;
    this.tiposApoyos = null;
    this.perfilesProyecto = null;
    this.experiencias = null;
    this.acreditaciones = null;
    this.beneficiarios = null;



    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });

    this.canVinculateDocto = false;


    this.formEncuesta = this.fb.group({
      idPresol: ['', [Validators.required]],
      idProductor: ['', [Validators.required]],
      idEncuesta: ['', [Validators.required]],
      preguntas: this.fb.array([]),
      multipleControl: this.fb.array([])
    });



  }


  createItem(idApoyo ,idConcepto, rfc, nombre, caracteristicas, necesidadApoyo){
    return this.fb.group({
      idApoyo: [idApoyo,[]],
      idConceptoApo: [idConcepto,[]],
      rfcProveedor: [rfc,[RfcValidator]],
      nombreProveedor: [nombre,[]],
      caracteristicas: [caracteristicas,[Validators.required]],
      necesidadApoyo: [necesidadApoyo,[]],
    });
  }


  addConceptoToList(apoyoParams){
    /*console.log(apoyoParams);
    console.log(apoyoParams.split('|'));*/
    let [concepto, desc_concepto_apoyo, requiere_proveedor ] = apoyoParams.split('|');

    requiere_proveedor = requiere_proveedor === 'true' ? true : false;

    const [ejercicio, id_programa, id_subprograma, id_componente, id_beneficio, id_concepto_apoyo ] = concepto.split('_');
    if(this.apoyos_agregado_helper.includes(concepto)){
      if(this.subprogramaMultiApoyo){
        const apoyosAdded = this.form.get('apoios') as FormArray;
        apoyosAdded.push(this.createItem('', id_concepto_apoyo,'', '', '', ''));
        this.apoyos_agregados.push({requiere_proveedor, desc_concepto_apoyo});
      }else{
        this.alertDialog('Atención', 'El concepto de apoyo ya se encuentra agregado', 'Cerrar');
      }
    }else{
      const apoyosAdded = this.form.get('apoios') as FormArray;
      apoyosAdded.push(this.createItem('', id_concepto_apoyo,'', '', '', ''));
      this.apoyos_agregados.push({requiere_proveedor, desc_concepto_apoyo});
    }
  }



  ngOnInit(){
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
   this.fileText = '';
   this.getParams();

   this.subscriptionBeneficiarios = this.totalBeneficioarios.valueChanges.subscribe(data => {
    //console.log('entrando a la suscripcion');
    //console.log(data);
    this.totalBeneficiarios = data.reduce((a,b) => a + +b.cantidad, 0);
    //console.log(this.totalBeneficiarios);
  });

  }

  get totalBeneficioarios() {
    //console.log(this.form.get('beneficiarios') as FormArray);
    return this.form.get('beneficiarios') as FormArray;
  }

  ngOnDestroy() {
    this.subscriptionBeneficiarios.unsubscribe();
  }

  tuvoApoyoChange(event){
    if(event.checked){
      this.form.get('ejercicioRecivido').enable();
      this.form.get('ejercicioRecivido').setValidators([Validators.required]);
      this.form.get('ejercicioRecivido').updateValueAndValidity();

      this.form.get('programaRecivido').enable();
      this.form.get('programaRecivido').setValidators([Validators.required]);
      this.form.get('programaRecivido').updateValueAndValidity();

      this.form.get('conceptoRecivido').enable();
      this.form.get('conceptoRecivido').setValidators([Validators.required]);
      this.form.get('conceptoRecivido').updateValueAndValidity();


    }else{
      this.form.get('ejercicioRecivido').disable();
      this.form.get('ejercicioRecivido').setValidators([]);

      this.form.get('programaRecivido').disable();
      this.form.get('programaRecivido').setValidators([]);

      this.form.get('conceptoRecivido').disable();
      this.form.get('conceptoRecivido').setValidators([]);
    }
  }

  alertDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(result);
    });
  }

  fileChangeEvent(event){
    //console.log('Formulario del documento');
    //console.log(this.formDoctos.value);
    if (event.target.files.length > 0) {
      //console.log(this.formDoctos.value);
      let file = event.target.files[0];
      //console.log(file);
      this.fileText = '(' + file.name + ')';
      this.formDoctos.get('file').setValue(file);
    }else{
      //console.log('archvio malito');
    }
  }

  changeZoom(zoom) {
    this.zoom = zoom;
  }

  onMapReady(map) {
    //console.log(map);
    //this.mapa = map;
    // this.initDrawingManager(map);
 }

 mapClicked($event: MouseEvent){
  this.form.get('latitudProyecto').setValue($event.coords.lat);
  this.form.get('longituProyecto').setValue($event.coords.lng);
  this.lat = $event.coords.lat;
  this.lng = $event.coords.lng;
  this.markers[0] = {
    lat: $event.coords.lat,
    lng: $event.coords.lng,
    draggable: true
  };
 }

 markerDragEnd(m: marker, $event: MouseEvent){
  this.form.get('latitudProyecto').setValue($event.coords.lat);
  this.form.get('longituProyecto').setValue($event.coords.lng);
  this.markers[0] = {
    lat: $event.coords.lat,
    lng: $event.coords.lng,
    draggable: true
  };
  this.lat = $event.coords.lat;
  this.lng = $event.coords.lng;
 }

 searchLocation(){
  const busqueda = this.form.get('buscando').value;
  const geocoder = new google.maps.Geocoder();
  if (busqueda === '' || busqueda === null ){
    //console.log('nada');


  }else{
    //console.log('here');
    geocoder.geocode({address: busqueda}, (results, status) => {
      //console.log(results);
      if (status === google.maps.GeocoderStatus.OK) {
        this.lat = results[0].geometry.location.lat();
        this.lng = results[0].geometry.location.lng();
      }
    });
  }
 }


  onSelectRequisito(){
    if (this.formDoctos.get('idRequisito').valid){
      if (this.formDoctos.get('idRequisito').value === ''){

        this.formDoctos.get('idDocumento').setValue('');
        this.documentos = [];

      }else{
        this.formDoctos.get('idDocumento').setValue('');
        this.comboService.getDocumentosForRequisito(this.formDoctos.get('idRequisito').value).subscribe(response => {
          //console.log(response);
          this.documentos = response;
        }, error => {
          console.log(error);
          this.alertDialog('Error', 'No hay documentos disponibles', 'Cerrar');
        });


      }
    }else{
      this.formDoctos.get('idDocumento').setValue('');
      this.documentos = [];
    }
  }


  getGeneralesUpaeg(idUpaeg){
    this.upaegService.getGralesUpaeg(idUpaeg).subscribe(response => {
      //console.log(response);
      if(response.status){
        this.upaeg = response.productor;

        if(response.productor.id_tipo_productor == 8 || response.productor.id_tipo_productor == '8'){
          //this.canVinculateDocto = true;
          this.canVinculateDocto = false;
        }else{
          this.canVinculateDocto = false;
        }

      }else{
        this.upaeg = null;
        this.mensaje = response.message;
        this.alertDialog('Error', response.message, 'Cerrar');
      }
    }, error => {
      console.log(error);
      this.upaeg = null;
      this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });
  }


  getDisponibilidadUpaeg(ejercicio, programa, subprograma, productor,idConcepto){
    this.solicitudesService.getDetallePresolConcepto(ejercicio,programa,subprograma,productor, idConcepto).subscribe(response => {
      //console.log('================');
      //console.log(response);
      //console.log('================');
      if(response.status){
        this.puedeRegistrar = true;


        if(response.requisitos){
          this.requisitos = response.requisitos;
        }else{
          this.requisitos = [];
        }


      }else{
        this.puedeRegistrar = false;
        this.mensaje = response.message;
        this.alertDialog('Atención', response.message, 'Cerrar');
      }
    }, error => {
      console.log(error);
      this.puedeRegistrar = false;
      this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });

  }

  getDocumentosEnlazados(idProductor, idPresolicitud){
    this.solicitudesService.getDocumentosEnlazadosPresolicitud(idProductor,idPresolicitud).subscribe(response => {
      //console.log(response);
      if(response.status){
        this.documentosEnalzados = response.documentos;
       // this.puedeRegistrar = true;
      }else{
        //this.puedeRegistrar = false;
        this.mensaje = response.message;
        this.alertDialog('Atención', response.message, 'Cerrar');
      }
    }, error => {
      console.log(error);
      this.puedeRegistrar = false;
      this.mensaje = 'No se pueden cargar los documentos enlazados, intente más tarde';
      this.alertDialog('Error', 'No se pueden cargar los documentos enlazados, intente más tarde', 'Cerrar');
    });


  }


  getRequisitosDisponiblesPresol(idProductor, idPresolicitud){
    //getRequisitosDIpiniblesPresol
    this.solicitudesService.getRequisitosDIpiniblesPresol(idProductor, idPresolicitud).subscribe(response => {
      //console.log('DETALLE DE LA PRESOLICITUD REQUISITOS');

      //console.log(response);
      if(response.status){
        if(response.requisitos){
          this.requisitos = response.requisitos;

        }else{
          this.requisitos = null;

        }

      }else{
        this.alertDialog('Atención', response.message, 'Cerrar');
      }

    }, error => {
      console.log(error);
      this.alertDialog('Error', 'No se pueden cargar los requisitos disponibles', 'Cerrar');

    });
  }

  getSistemaProductoSolicitud(ejercicio, presol){
    // ejercicio
    //this.form.get('ejercicio').value,
    //this.form.get('idPresol'
    this.solicitudesService.getSistemasProductoRegistrados(ejercicio, presol).subscribe(response => {
      //console.log(response);

      if(response.status){
        this.sistemsProdSolicitud = response.sistemas;

      }else{
        this.sistemsProdSolicitud = null;
      }
    }, error => {
      this.sistemsProdSolicitud = null;
      console.log(error);
      this.alertDialog('Error', 'No se pueden cargar los sistemas producto, error 102', 'Cerrar');
    });
    //this.form.get('ejercicio').setValue(response.apoyos[0].ejercicio);
    //this.form.get('idPresol').setValue(idPresolicitud);


  }


  getStatusPresol(idPresolicitud){
    this.solicitudesService.getPresolStatus(idPresolicitud).subscribe(response => {
      console.log('response status');
      console.log(this.tieneValidaciones)
      console.log(response);
      console.log('response status');
      if(response.status){
        if(response.editar == false){
          this.form.disable();
          this.forSisProd.disable();
        }

        let apoyosAdded = this.form.get('apoios') as FormArray;
        apoyosAdded.controls.forEach(element => {
          if(response.tiene_validaciones){
            //element['controls']['rfcProveedor'].read();
            //element['controls']['nombreProveedor'].disable();
          }

          /*element['controls']['nombreProveedor']
          console.log(element);
          console.log(element['controls']['nombreProveedor'].value);*/
        });


        this.canSend = response.validar;
        this.canEdit = response.editar;
        this.obsEdit = response.obsEdicion;
        this.obsSend = response.obsValidacion;
        console.log(this.tieneValidaciones)
        this.tieneValidaciones = response.tiene_validaciones;
        console.log(this.tieneValidaciones)

        if(!this.canEdit){
          this.formEncuesta.disable();
        }


      }else{
        this.formEncuesta.disable();
        this.canEdit = false;
        this.canSend = false;
        this.form.disable();
        this.obsEdit.push('No se encontró información, error 102');
      }

    }, error => {
      console.log(error);
      this.formEncuesta.disable();
      this.canEdit = false;
      this.canSend = false;
      this.obsEdit.push('No se pueden cargar los sistemas producto agregados a la información del expediente');
      this.alertDialog('Error', 'No se pueden cargar los sistemas producto agregados a la información del expediente', 'Cerrar');
    });
  }

  getDetallesPresolicitud(idProductor, idPresolicitud){



    this.solicitudesService.getDetallePresolicitud(idProductor, idPresolicitud).subscribe(response => {
      //console.log('HEREEEE');
      console.log(response);
      if(response.status){

        this.haveEncuesta = response.encuesta_enabled;
        //encuestaRespondida
        //this.encuestaRespondida = true;
        //VALIDAR SI LA ENCUESTA YA ESTA RESPONDIDA//

        if(response.encuesta_enabled){
          if(response.encuesta_respondida){
            this.encuestaRespondida = true;
          }

          response.encuestas.forEach(encuesta => {
            this.formEncuesta.get('idPresol').setValue(idPresolicitud);
            this.formEncuesta.get('idProductor').setValue(idProductor);
            this.formEncuesta.get('idEncuesta').setValue(encuesta.id_encuesta);

            this.preguntas = encuesta.preguntas;
            this.encuestaTitle = encuesta.desc_encuenta;
            this.encuestaInstrucciones = encuesta.introduccion;
            encuesta.preguntas.forEach(pregunta => {
              this.addItemPregunta(pregunta.multiple, pregunta.obligatoria, pregunta.respuestas);
            });
          });

          if(!this.canEdit){
            this.formEncuesta.disable();
          }

          
          /*console.log('this.preguntas');
          console.log(this.preguntas);
          console.log('this.preguntas');*/
        }else{
          this.preguntas = [];
        }

        this.puedeRegistrar = true;
        this.form.get('idProductor').setValue(idProductor);
        this.form.get('idPresol').setValue(idPresolicitud);
        this.formValidacion.get('idPresol').setValue(idPresolicitud);

        this.subprogramaMultiApoyo = response.subPrograma.multiapoyo;


        if(response.apoyos){
          this.apoyos_disponibles = response.apoyos;
          this.form.get('ejercicio').setValue(response.apoyos[0].ejercicio);
          this.formDoctos.get('ejercicio').setValue(response.apoyos[0].ejercicio);
          this.formDoctos.get('idPrograma').setValue(response.apoyos[0].id_programa);
          this.formDoctos.get('idSubprograma').setValue(response.apoyos[0].id_subprograma);
          this.formDoctos.get('idConceptoDeApoyo').setValue(response.apoyos[0].id_concepto_apoyo);
          this.formValidacion.get('ejercicio').setValue(response.apoyos[0].ejercicio);
          this.getSistemaProductoSolicitud(response.apoyos[0].ejercicio,idPresolicitud);
        }

        if(response.apoyosSeleccionados){
          this.apoyos_agregados = response.apoyosSeleccionados;
          this.haveApoyoSelected = true;

          this.apios = this.form.get('apoios') as FormArray;
          this.apios.clear();

          response.apoyosSeleccionados.forEach(apoyo_agregado => {
            const apoyo_code = apoyo_agregado.ejercicio+'_'+apoyo_agregado.id_programa+'_'+apoyo_agregado.id_subprograma+'_'+apoyo_agregado.id_componente+'_'+apoyo_agregado.id_beneficio+'_'+apoyo_agregado.id_concepto_apoyo;
            if(!this.apoyos_agregado_helper.includes(apoyo_code)){
              this.apoyos_agregado_helper.push(apoyo_code);
            }

            this.apios.push(this.createItem(apoyo_agregado.id_apoyo,apoyo_agregado.id_concepto_apoyo, apoyo_agregado.rfc_proveedor, apoyo_agregado.nom_proveedor, apoyo_agregado.caracteristicas, apoyo_agregado.descripcion_necesidad));

          });

        }

        if(!this.canEdit){
          this.form.disable();
        }

        this.updateApoyosDisponiblesList();




        this.presolStatus = response.presolStatus;

        if(response.tiposApoyo){
          this.tiposApoyos = response.tiposApoyo;
        }else{
          this.tiposApoyos = null;
        }


        if(response.tiposApoyo){
          this.perfilesProyecto = response.perfilesProyect;
        }else{
          this.perfilesProyecto = null;
        }

        if(response.experiencias){
          this.experiencias = response.experiencias;
        }else{
          this.experiencias = null;
        }

        if(response.acreditaciones){
          this.acreditaciones = response.acreditaciones;
        }else{
          this.acreditaciones = null;
        }

        this.form.get('empDirectosH').setValue(response.presolicitud[0].empleos_directos_h);
        this.form.get('empDirectosM').setValue(response.presolicitud[0].empleos_directos_m);
        this.form.get('empEventH').setValue(response.presolicitud[0].empleos_eventuales_h);
        this.form.get('empEventM').setValue(response.presolicitud[0].empleos_eventuales_m);
        this.form.get('empIndirectos').setValue(response.presolicitud[0].empleos_indirectos);

        this.form.get('isMigrante').setValue(response.presolicitud[0].migrante);
        this.form.get('isJefeDeFamilia').setValue(response.presolicitud[0].jefe_de_familia);
        this.form.get('haveApoyo').setValue(response.presolicitud[0].ha_recibido_apoyo);
        if(response.presolicitud[0].ha_recibido_apoyo){
          this.form.get('ejercicioRecivido').enable();
          this.form.get('ejercicioRecivido').setValidators([Validators.required]);
          this.form.get('ejercicioRecivido').updateValueAndValidity();

          this.form.get('programaRecivido').enable();
          this.form.get('programaRecivido').setValidators([Validators.required]);
          this.form.get('programaRecivido').updateValueAndValidity();

          this.form.get('conceptoRecivido').enable();
          this.form.get('conceptoRecivido').setValidators([Validators.required]);
          this.form.get('conceptoRecivido').updateValueAndValidity();

        }else{
          this.form.get('ejercicioRecivido').disable();
          this.form.get('ejercicioRecivido').setValidators([]);

          this.form.get('programaRecivido').disable();
          this.form.get('programaRecivido').setValidators([]);

          this.form.get('conceptoRecivido').disable();
          this.form.get('conceptoRecivido').setValidators([]);

        }


        this.form.get('ejercicioRecivido').setValue(response.presolicitud[0].recibido_a_ejercicio);
        this.form.get('programaRecivido').setValue(response.presolicitud[0].recibido_a_programa);
        this.form.get('conceptoRecivido').setValue(response.presolicitud[0].recibido_a_concepto);
        this.form.get('obserbacionesSolicitud').setValue(response.presolicitud[0].observaciones);


        if(response.proyecto){
          this.tieneProyecto = true;
          this.form.get('nombreProyecto').setValue(response.proyecto[0].nombre_proyecto);
          this.form.get('descProyecto').setValue(response.proyecto[0].descripcion_proyecto);
          this.form.get('actividadPrincipal').setValue(response.proyecto[0].actividad_principal);
          if(response.proyecto[0].infraestructura_suficiente){
            this.form.get('havInfraestructura').setValue('t');

          }else{
            this.form.get('havInfraestructura').setValue('f');

          }




          this.form.get('idPerfilProyecto').setValue(response.proyecto[0].id_perfil_proyecto);
          this.form.get('idTipoProyecto').setValue(response.proyecto[0].id_tipo_proyecto);
          this.form.get('idExperiencia').setValue(response.proyecto[0].id_experiencia);
          this.form.get('idAcreditacionInfraestructura').setValue(response.proyecto[0].id_acreditacion_infraestructura);
          this.form.get('montoTotalDelProyecto').setValue(response.proyecto[0].monto_total_proyecto);
          this.form.get('idEdoProyecto').setValue(response.proyecto[0].id_edo);
          this.form.get('idMunProyecto').setValue(response.proyecto[0].id_mun);
          this.form.get('idLocProyecto').setValue(response.proyecto[0].id_loc);
          this.onSelectEstado();
          this.onSelectMun();

          this.form.get('idTipoAcentamientoProyecto').setValue(response.proyecto[0].id_tipo_asentamiento);
          this.form.get('nombreAcentamientoProyecto').setValue(response.proyecto[0].nom_asentamiento);
          this.form.get('idTipoVialidadProyecto').setValue(response.proyecto[0].id_tipo_vialidad);
          this.form.get('nombreVialidadProyecto').setValue(response.proyecto[0].nom_vialidad);
          this.form.get('noExterior').setValue(response.proyecto[0].numero_ext);
          this.form.get('noInterior').setValue(response.proyecto[0].numero_int);
          this.form.get('codigoPostal').setValue(response.proyecto[0].codigo_postal);
          this.form.get('telefonoDeContacto').setValue(response.proyecto[0].telefono);



          if(response.proyecto[0].geo_latitud != null && response.proyecto[0].geo_latitud != '' && response.proyecto[0].geo_latitud != 0){
            this.form.get('latitudProyecto').setValue(response.proyecto[0].geo_latitud);
            this.form.get('longituProyecto').setValue(response.proyecto[0].geo_longitud);


            this.lat = response.proyecto[0].geo_latitud*1;
            this.lng = response.proyecto[0].geo_longitud*1;

            this.zoom = 18;

            this.markers[0] = {
              lat: response.proyecto[0].geo_latitud*1,
              lng: response.proyecto[0].geo_longitud*1,
              draggable: true
            };



          }



        }else{
          this.tieneProyecto = false;
        }


      }else{
        this.puedeRegistrar = false;
        this.mensaje = response.message;
        this.alertDialog('Error', response.message, 'Cerrar');
      }

      console.log(this.form.value);


    }, error => {
      console.log(error);
      this.alertDialog('Error', 'No se puede cargar la información del expediente', 'Cerrar');
    });



  }


  updateApoyosDisponiblesList(){
    this.apoyos_disponibles_list = [];
    this.apoyos_disponibles.forEach(apoyo => {
      const apoyo_code = apoyo.ejercicio+'_'+apoyo.id_programa+'_'+apoyo.id_subprograma+'_'+apoyo.id_componente+'_'+apoyo.id_beneficio+'_'+apoyo.id_concepto_apoyo;
      if(this.apoyos_agregado_helper.includes(apoyo_code)){
        if(this.subprogramaMultiApoyo){
          this.apoyos_disponibles_list.push(apoyo);
        }
      }else{
        this.apoyos_disponibles_list.push(apoyo);
      }
    });
  }

  deleteFile(idPrecaptura, idRequisito, idTipoDocumento, idDocumento, idConsecutivo){
    //deleteDocumentoSolicitud
    const dialogRef = this.dialog.open(ConfirmPopComponent, {
      width: '40%',
      data: {
        titulo: 'Atención',
        // tslint:disable-next-line:max-line-length
        texto: '¿En verdad desea eliminar el documento seleccionado?, este cambio no se puedes deshacer',
        confirm: 'Eliminar documento',
        cancel: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // tslint:disable-next-line: max-line-length
        this.solicitudesService.deleteDocumentoSolicitud({idPrecaptura, idRequisito, idTipoDocumento, idDocumento, idConsecutivo}).subscribe(response => {
          //console.log(response);
          if (response.status) {
            this.getDetallePresolicitud(this.idProducer, this.idPresol);
            this.openAlert('Eliminado', response.message, 'Cerrar');
          } else {
            this.openAlert('Error', response.message, 'Cerrar');
          }
        }, error => {
          console.log(error);
          this.openAlert('Error', 'No se pude procesar su solicitud en este momento, intenté nuevamente', 'Cerrar');
        });
      }
    });

  }


  getApoyosForPresolicitud(idProductor, idPresolicitud) {
    this.solicitudesService.getApoyosForSolicitud(idProductor, idPresolicitud).subscribe(response => {
      //console.log(response);
      if (response.status) {
        //
        if(response.apoyos){
          this.apoyosSolicitud = response.apoyos;
        }else{
          this.apoyosSolicitud = null;
        }

      } else {
        this.openAlert('Error', response.message, 'Cerrar');
      }
    }, error => {
      console.log(error);
      this.openAlert('Error', 'No se pude procesar su solicitud en este momento, intenté nuevamente', 'Cerrar');
    });
    /*
    getApoyosForSolicitud
     */
  }

  loadCombos(){
    this.comboService.getEstados().subscribe(response => {
      this.estados =  [];
      response.forEach((estado,key) => {
        if(estado.id_edo == 11){
          //console.log('Agregando estado');

          this.estados.push(estado);
        }else{
          //console.log('No se agrega '+estado.id_edo);
        }
      });
      /*response.forEach((element,key) => {
        console.log(element);
        console.log(element.nom_edo);
        console.log(key);
        if(element.id_edo == 11){
          console.log('Agregando estado');
          this.estados[key] = element;
        }else{
          console.log('No se agrega'+element.id_edo);
        }
      });*/
      //this.estados = response;
    }, error => {
      console.log(error);
      this.openAlert('Error', 'Error al obtener los estados', 'Cerrar');
    });


    this.comboService.getTiposSistemaProd().subscribe(response => {
      this.tiposSistemaProd = response;
    }, error => {
      console.log(error);
      this.openAlert('Error', 'Error al obtener los tipos de sistema producto', 'Cerrar');
    });


    this.comboService.getAsentamientos().subscribe(response => {
      this.asentamientos = response;
    }, error => {
      console.log(error);
      this.openAlert('Error', 'Error al obtener los asentamientos', 'Cerrar');
    });

    this.comboService.getVialidades().subscribe(response => {
      this.vialidades = response;
    }, error => {
      console.log(error);
      this.openAlert('Error', 'Error al obtener las vialidades', 'Cerrar');
    });



  }

  onSelectEstado() {
    /*
    idEdoProyecto: ['', [Validators.required]],
      idMunProyecto: ['', [Validators.required]],
      idLocProyecto: ['', [Validators.required]],
     */
    if (this.form.get('idEdoProyecto').valid) {
     // this.form.get('idMunProyecto').setValue('');
     // this.form.get('idLocProyecto').setValue('');
      this.comboService.getMunicipios(this.form.get('idEdoProyecto').value).subscribe(response => {
        this.municipios = response;
        if (this.form.get('idEdoProyecto').value === '') {
          this.form.get('idMunProyecto').setValue('');
          this.form.get('idLocProyecto').setValue('');
        }
      }, error => {
        console.log(error);
        this.openAlert('Error', 'Error al obtener los municipios', 'Cerrar');
      });

    } else {
      this.municipios = [];
      this.form.get('idMunProyecto').setValue('');
      this.form.get('idLocProyecto').setValue('');
    }
  }

  onSelectMun() {
    if (this.form.get('idEdoProyecto').valid && this.form.get('idMunProyecto').valid) {
      //console.log('Valido localidad');
      this.comboService.getLocalidades(this.form.get('idEdoProyecto').value, this.form.get('idMunProyecto').value).subscribe(response => {
        this.localidades = response;
        if (this.form.get('idMunProyecto').value === '') {
          this.form.get('idLocProyecto').setValue('');
        }
      }, error => {
        console.log(error);
        this.openAlert('Error', 'Error al obtener las localidades', 'Cerrar');
      });
    } else {
      this.localidades = [];
      this.form.get('idLocProyecto').setValue('');
    }
  }


  getDetallePresolicitud(idProductor, idPresolicitud){
    this.formDoctos.get('idRequisito').setValue('');
    this.formDoctos.get('idDocumento').setValue('');
    this.formDoctos.get('file').setValue('');
    this.formDoctos.get('helperfile').setValue('');
    this.fileText = '';
    this.documentos = [];
    this.getDocumentosEnlazados(idProductor, idPresolicitud);
    this.getRequisitosDisponiblesPresol(idProductor, idPresolicitud);
    this.getDetallesPresolicitud(idProductor, idPresolicitud);
    this.getStatusPresol(idPresolicitud);
    this.loadCombos();
    // this.getApoyosForPresolicitud(idProductor, idPresolicitud);
  }

  private prepareSave(): any{
    let formu = new FormData();
    formu.append('idProductor', this.formDoctos.get('idProductor').value);
    formu.append('idPresol', this.formDoctos.get('idPresol').value);
    formu.append('ejercicio', this.formDoctos.get('ejercicio').value);
    formu.append('idPrograma', this.formDoctos.get('idPrograma').value);
    formu.append('idSubprograma', this.formDoctos.get('idSubprograma').value);
    formu.append('idConceptoDeApoyo', this.formDoctos.get('idConceptoDeApoyo').value);
    formu.append('idRequisito', this.formDoctos.get('idRequisito').value);
    formu.append('idDocumento', this.formDoctos.get('idDocumento').value);
    formu.append('documentoToEnlace', this.formDoctos.get('file').value);
    return formu;
  }

  openAlert(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(result);
    });
  }

  openDialogRedirect(title, text, action, direction): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/' + direction]);
    });
  }


  onSubmit(formulario){
    const formData = this.prepareSave();
    this.solicitudesService.saveDocumento(formData).subscribe(response => {
      console.log(response);
      if(response.status){
        if(response.new){
          let idProducer = this.formDoctos.get('idProductor').value;
          let idPresol = response.idPresolicitud;
          this.openDialogRedirect('Guardado', response.message, 'Cerrar', 'presolicitud/'+idProducer+'/'+idPresol);
        }else{
          //Cargar informacion de nuevo del folio actualizado
          //helperfile
          this.getDetallePresolicitud(this.formDoctos.get('idProductor').value, this.formDoctos.get('idPresol').value);
        }
      }else{
        this.openAlert('Error', response.message, 'Cerrar');
      }

    }, error => {
      console.log(error);
      this.openAlert('Error', 'No se pude procesar su solicitud en este momento, intenté nuevamente', 'Cerrar');
    });

  }


  onSubmitSoli(formulario){
    console.log(this.form.value);
    this.solicitudesService.savePresolicitud(this.form.value).subscribe(response => {
      console.log(response);
      if(response.status){
        this.tieneProyecto = true;
        //console.log('----AAAAAA----');
        this.openAlert('Guardado', response.message, 'Cerrar');
      }else{
        //console.log('----BBBBBB----');
        this.openAlert('Atención', response.message, 'Cerrar');
      }
    }, error => {
      //console.log('--------');
      console.log(error);
      this.openAlert('Error', 'No se puede cargar la información del expediente en este momento, error interno', 'Cerrar');
    });/**/
  }


  createItemBeneficiari(idComb, cantidad){
    return this.fb.group({
      idCombinacion: [idComb,[Validators.required]],
      cantidad: [cantidad,[Validators.required]]
    });
  }


  getCombeneficiarios(iPre = null){

   if(iPre == null){
     //console.log('Sin presol');
      this.solicitudesService.getBeneficiariosCampos().subscribe(response =>{
        //console.log(response);

        if(response.status){
          this.beneficiarios = response.data;
          this.beneficiariosArr = this.form.get('beneficiarios') as FormArray;
          this.beneficiariosArr.clear();

          response.data.forEach(tipoBen => {

            //createItemBeneficiari
            //beneficiarios: this.fb.array([]),
            //beneficiariosArr
            this.beneficiariosArr.push(this.createItemBeneficiari(tipoBen.id_combinacion, 0));

          });
        }else{
          this.beneficiarios = null;
        }
      }, error =>{
        console.log(error);
        this.openAlert('Error', 'No se puede cargar la información del expediente en este momento, error interno', 'Cerrar');
      });
    }else{
      //console.log('Con presolicitud');
      this.solicitudesService.getBeneficiariosCampos(iPre).subscribe(response =>{
        //console.log(response);
        if(response.status){
          this.beneficiarios = response.data;
          this.beneficiariosArr = this.form.get('beneficiarios') as FormArray;
          this.beneficiariosArr.clear();
          response.data.forEach(tipoBen => {
            //createItemBeneficiari
            //beneficiarios: this.fb.array([]),
            let cantidad = 0;
            if(tipoBen.cantidad != null){
              cantidad = tipoBen.cantidad;
            }
            this.beneficiariosArr.push(this.createItemBeneficiari(tipoBen.id_combinacion, cantidad));

          });
        }else{
          this.beneficiarios = null;
        }
      }, error =>{
        console.log(error);
        this.openAlert('Error', 'No se puede cargar la información del expediente en este momento, error interno', 'Cerrar');
      });/**/
    }
    //this.form.get('apoyosSolicitudInput').setValue(apoHelper);
    //console.log('Evento de beneficiarios');
    //console.log(this.form.value);
    //console.log('Evento de beneficiarios');


  }

  getParams(){
    this.route.params.subscribe(params => {
      //console.log(params);
      if (params.a && params.b && params.c && params.d && params.e){
        //console.log('TIENE TODO PARA NUEVA');
        this.formDoctos.get('idProductor').setValue(params.a);
        this.formDoctos.get('ejercicio').setValue(params.b);
        this.formDoctos.get('idPrograma').setValue(params.c);
        this.formDoctos.get('idSubprograma').setValue(params.d);
        this.formDoctos.get('idConceptoDeApoyo').setValue(params.e);
        this.isNew = true;
        this.idProducer = params.a;
        this.idPresol = 0;
        this.getGeneralesUpaeg(params.a);
        this.getDisponibilidadUpaeg(params.b,params.c,params.d,params.a,params.e);
        this.getCombeneficiarios();
      }else{
        if (params.a && params.b){
          this.isNew = false;
          //console.log('ESTA MOFICANMDO INFORMACION');
          this.getGeneralesUpaeg(params.a);
          this.getDetallePresolicitud(params.a, params.b);
          this.formDoctos.get('idProductor').setValue(params.a);
          this.formDoctos.get('idPresol').setValue(params.b);
          this.idProducer = params.a;
          this.idPresol = params.b;
          this.getCombeneficiarios(this.idPresol);
          this.getStatusPresol(params.b);

        }else{
          this.router.navigate(['/apoyos']);
        }

      }


    });

  }

  checkStatus(evento){
    if(evento.index > 0){
      if(this.idPresol == 0){
        this.tabIndex = 0;
        this.openAlert('Atención', 'Primero debe enlazar los documentos necesarios para completar su expediente, después podrá ingresar la información del apoyo', 'Cerrar');
      }else{
        //VALIDAR ESTADO DE LA PRESOLICITUD
        if(evento.index == 4){
          this.getStatusPresol(this.idPresol);
        }

        if(evento.index == 1){
          this.solicitudesService.getRequisitosNoCumplidos(this.idProducer, this.idPresol).subscribe(response => {
            console.log(response);
            if(response.status){
              this.tabIndex = evento.index;
            }else{
              this.tabIndex = 0;

              let tabla = '<br><div class="table-responsive mt-2"><table class="table"><thead><tr><th scope="col">#</th><th scope="col">Requisito obligatorio faltante</th></tr></thead><tbody>';
              response.documentos_sin_enlazar.forEach((doc, key) => {
                const numero = key*1 + 1;
                tabla += '<tr><th>'+numero+'</th><td>'+doc.desc_requisito_conv+'</td></tr>';
              });
              tabla += '</tbody></table></div>';

              this.openAlert('Atención', response.message+tabla, 'Cerrar');
            }
          }, error => {
            console.log(error);
            this.tabIndex = 0;
            this.openAlert('Atención', 'En este momento no se puede validar su expediente, error interno', 'Cerrar');
          });
        }





        if(evento.index == 2){
          if(this.tieneProyecto){
            this.tabIndex = evento.index;
          }else{
            this.tabIndex = 1;
            this.openAlert('Atención', 'Debe completar la información de su solicitud en la pestaña de información general para agregar sistemas producto', 'Cerrar');
          }
        }




      }

    }else{
      this.tabIndex = 0;
      /*if(this.idPresol == 0){
        this.tabIndex = 0;
        this.openAlert('Atención', 'Primero debe enlazar los documentos necesarios para completar su expediente, después podrá ingresar la información del apoyo', 'Cerrar');
      }else{
        if(evento.index == 2){
          this.tabIndex = 2;
          this.getStatusPresol(this.idPresol);
        }

      }*/
    }
  }

  onSelectTiposSistema(){
    if ((this.forSisProd.get('idTipoSistemaProd').value == '' || this.forSisProd.get('idTipoSistemaProd').value == null) && this.forSisProd.get('idTipoSistemaProd').value != 0){
      this.sistemasProdu = [];
      this.forSisProd.get('idSistemProd').setValue(null);
    }else{
      this.comboService.getSistemaProductutoForTipo(this.forSisProd.get('idTipoSistemaProd').value).subscribe(response => {
        this.sistemasProdu = response;
        this.forSisProd.get('idSistemProd').setValue(null);
      }, error => {
        console.log(error);
        this.openAlert('Atención', 'No se pueden cargar los sistemas productos para la categoría seleccionada', 'Cerrar');
      });
    }
  }
// HERE WE ARE
  addSisProducto(){
    let idTipoSistema = this.forSisProd.get('idTipoSistemaProd').value;
    let idSistema = this.forSisProd.get('idSistemProd').value;
    let idPresol = this.form.get('idPresol').value;
    let ejercicio = this.form.get('ejercicio').value;



    if(idSistema === null || idTipoSistema === null ){
      this.openAlert('Atención', 'Debe indicar el tipo de sistema producto y el sistema producto para agregarlo al expediente', 'Cerrar');
    }else{
      this.solicitudesService.saveSistemaProducto({idTipoSistema, idSistema, idPresol, ejercicio}).subscribe(response => {
        //console.log(response);

        if(response.status){
          this.getSistemaProductoSolicitud(this.form.get('ejercicio').value,this.form.get('idPresol').value);
          this.forSisProd.get('idTipoSistemaProd').setValue(null);
          this.forSisProd.get('idSistemProd').setValue(null);
          this.openAlert('Atención', response.message, 'Cerrar');
        }else{
          this.openAlert('Atención', response.message, 'Cerrar');
        }

      }, error => {
        console.log(error);
        this.openAlert('Atención', 'No se puede agregar el sistema producto, error interno', 'Cerrar');
      });
    }

  }


  deleteSistemaProducto(ejercicio, id_pre_captura, id_tipo_sistema_prod, id_sistema_prod){
    this.solicitudesService.deleteSistemaProducto({ejercicio, id_pre_captura, id_tipo_sistema_prod, id_sistema_prod}).subscribe(response => {
      //console.log(response);
      if(response.status){
        this.getSistemaProductoSolicitud(ejercicio,id_pre_captura);
          this.openAlert('Atención', response.message, 'Cerrar');
      }else{
        this.openAlert('Atención', response.message, 'Cerrar');
      }
    }, error => {
        console.log(error);
        this.openAlert('Atención', 'No se puede borrar el sistema producto, error interno', 'Cerrar');
    });
  }


  cambioSeleccion(event, opcionesSeleccionadas){
    //console.log('Cambio de seleccion');
    //console.log(event);
    //console.log(opcionesSeleccionadas);

    this.haveApoyoSelected = opcionesSeleccionadas > 0 ? true : false;

    //this.cantidadApoyosSeleccionados = true;


  }


  recibirNotiChanges(event){
    //console.log(event);
    let identidad = this.userService.getIdentity();
    //console.log(this.userService.getIdentity());
    if(event.checked){
      //console.log('Quiere notificaciones');
      this.form.get('emailNvo').setValue(identidad.email);
      this.form.get('emailNvo').enable();
      this.form.get('emailNvo').setValidators([Validators.required]);
      this.form.get('emailNvo').updateValueAndValidity();


      this.form.get('updateEmailUpaeg').setValue(false);
      this.form.get('updateEmailUpaeg').enable();
    }else{
      //console.log('NO Quiere notificaciones');
      this.form.get('emailNvo').setValue('');
      this.form.get('emailNvo').disable();
      this.form.get('emailNvo').setValidators([]);
      this.form.get('emailNvo').updateValueAndValidity();

      this.form.get('updateEmailUpaeg').setValue(false);
      this.form.get('updateEmailUpaeg').disable();
    }
  }


  sendToValidation(formulario){
    let presol = this.idPresol;
    // console.log(this.formValidacion.value);
    this.solicitudesService.sendToValidation(this.formValidacion.value).subscribe(response => {
      //console.log(response);

      if(response.status){
        this.openAlert('Guardado', response.message, 'Cerrar');
        this.getDetallePresolicitud(this.formDoctos.get('idProductor').value, this.formDoctos.get('idPresol').value);
      }else{
        this.openAlert('Atención', response.message, 'Cerrar');
      }

    }, error => {
      console.log(error);
      this.openAlert('Error', 'No se pude enviar a validación, error interno 102', 'Cerrar');
    });

  }

  /*

  getSistemaProductoSolicitud(ejercicio, presol){
    // ejercicio
    //this.form.get('ejercicio').value,
    //this.form.get('idPresol'


  idTipoSistemaProd: ['', []],
      idSistemProd: ['', []]


if (this.form.get('idEdoProyecto').valid) {
     // this.form.get('idMunProyecto').setValue('');
     // this.form.get('idLocProyecto').setValue('');
      this.comboService.getMunicipios(this.form.get('idEdoProyecto').value).subscribe(response => {
        this.municipios = response;
        if (this.form.get('idEdoProyecto').value === '') {
          this.form.get('idMunProyecto').setValue('');
          this.form.get('idLocProyecto').setValue('');
        }
      }, error => {
        console.log(error);
        this.openAlert('Error', 'Error al obtener los municipios', 'Cerrar');
      });

    } else {
      this.municipios = [];
      this.form.get('idMunProyecto').setValue('');
      this.form.get('idLocProyecto').setValue('');
    }
  */



  /*
getTiposSistemaProd(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/tipos/sistema/producto', { headers });
   }

   getSistemaProductutoForTipo(idTipoSistema): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/sistema/producto/' + idTipoSistema, { headers });
   }
  */

   openLinkDocumentWindow(): void {


    const dialogRef = this.dialog.open(VincularDocumentoExpedienteComponent, {
      width: '80%',
      data: {
        idProductor: 0,
        idPresol: 0,
        ejercicio: 0,
        idPrograma: 0,
        idSubprograma: 0,
        idConceptoDeApoyo: 0,
        idRequisito: 0,
        idDocumento: 0
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
      if (result){
        console.log('Resultados del pop');
        console.log(result);
        //this.router.navigate(['/' + direction]);
      }
    });
  }


   vincularDocumento(){
     this.openLinkDocumentWindow();
   }


   removeConcepto(apoyo_agregado, i){
     console.log('Eliminar concepto');
     console.log(apoyo_agregado);
     this.updateApoyosDisponiblesList();
     let apoyos_form_added = this.form.get('apoios').value;
     let cantidadMismoApoyo = apoyos_form_added.filter(apoyo => apoyo.idConceptoApo === apoyo_agregado.id_concepto_apoyo).length;

     let idConceptosFromHelper = this.apoyos_agregado_helper.map(apoyo => {
      return apoyo.split('_')[5];
     });

      if(cantidadMismoApoyo <= 1){
        let indexToDelete = idConceptosFromHelper.indexOf(apoyo_agregado.id_concepto_apoyo);
        //ELIMINAR EL CONCEPTO DE LA LISTA DE APOYOS USADOS POR QUE NO ESTA AGREGADO
        this.apoyos_agregado_helper.splice(indexToDelete, 1);
      }

      //ELIMINAMOS DEL ARRAY DE APOYOS AGREGADOS
      this.apoyos_agregados.splice(i, 1);
      console.log('ApoyosAgregados',this.apoyos_agregados);

      //ELIMINAMOS DEL FORMULARIO
      const apoyosAdded = this.form.get('apoios') as FormArray;
      apoyosAdded.removeAt(i);


     console.log('Apoyos agregados helper',this.apoyos_agregado_helper);
     console.log('Formulario',this.form.value);
     console.log('aPOYOS RESTANTES',this.form.get('apoios').value);

     this.updateApoyosDisponiblesList();
   }

   get preguntasArray() {
    return this.formEncuesta.get('preguntas') as FormArray;
  }



   addItemPregunta(multiple = false, obligatoria = false, respuestas = []): void{
    this.preguntasArr = this.form.get('preguntas') as FormArray;
    this.multipleControl = this.form.get('multipleControl') as FormArray;
    let arrayToPush = this.createItemPregunta(multiple, obligatoria, respuestas);
    this.preguntasArray.push(arrayToPush);
    if (multiple && obligatoria){
      console.log('Es multiple y oglicatoria');
      let hiddenControl = new FormControl(this.mapItems(arrayToPush.value), Validators.required);
      arrayToPush.valueChanges.subscribe((v) => {
        console.log(v);
        hiddenControl.setValue(this.mapItems(v));
      });
      this.multipleControl.push(new FormGroup({
        selectedItems: hiddenControl
      }));
    }

    console.log('this.formEncuesta.value');
    console.log(this.formEncuesta.value);
    console.log('this.formEncuesta.value');
  }

  mapItems(items){
    let selectedItems = items.filter((item) => item.valor).map((item) => item.valor);
    return selectedItems.length  ? selectedItems : null;
  }


  createItemPregunta(multiple = false, obligatoria = false, respuestas): any{
    let resps = [] ;
    let respuests = [];
    let resp = '';
    let textoOpc = '';

    if (respuestas){
      respuestas.forEach(respuesta => {
        let valor = null;
        let validatorsA = [];
        let validators = [];

        if(respuestas.length === 1){
          if(respuesta.tipo === 'integer'){
            valor = respuesta.id_encuesta + '_' + respuesta.id_pregunta + '_' + respuesta.id_respuesta;
            validators = [Validators.required];
          }

          if(respuesta.tipo === 'text'){
            valor = respuesta.id_encuesta + '_' + respuesta.id_pregunta + '_' + respuesta.id_respuesta;
            validators = [Validators.required];
          }
        }


        if(obligatoria && !multiple){
          validatorsA = [Validators.required];
        }

        let grupoResp = new FormGroup({
          valor : new FormControl(valor, validatorsA),
          texto: new FormControl(null, validators)
        });

        if (multiple){
          respuests.push(grupoResp);
        }else{
          respuests[0] = grupoResp;
        }
      });

    }

    //multipleControl

    return this.fb.array(respuests, [Validators.required]);

  }


  onCheckboxChange(e, i, j): void{
    // console.log(this.form.value);

    /*
    console.log(preguntas.controls[i]);
    const preguntas = this.preguntasArray;
    const respuestas = preguntas.controls[i] as FormArray;
    const respuesta = respuestas.controls[0];
    const tipo = this.preguntas[i].respuestas[j].tipo;
    */
    //const preguntas: FormArray = this.form.get('preguntas') as FormArray;
    const preguntas: FormArray = this.preguntasArray;
    const respuestas: FormArray = preguntas.controls[i] as FormArray;
    const respuesta = respuestas.controls[j];
    const tipo = this.preguntas[i].respuestas[j].tipo;


    if (e.checked){
      respuesta.get('valor').setValue(e.source.value);
      if (tipo === 'text'){
        respuesta.get('texto').setValidators([Validators.required]);
      }
      if (tipo === 'integer'){
        respuesta.get('texto').setValidators([Validators.required]);
      }
      respuesta.get('texto').updateValueAndValidity();
    }else{
      respuesta.get('valor').setValue(null);
      if (tipo === 'text'){
        respuesta.get('texto').clearValidators();
      }
      if (tipo === 'integer'){
        respuesta.get('texto').clearValidators();
      }
      respuesta.get('texto').updateValueAndValidity();
    }
    this.cotejaForm();
  }

  /*get preguntasArray() {
    return this.formEncuesta.get('preguntas') as FormArray;
  }*/

  onRadioChange(e, i, j){
    //this.preguntasArray
    //const preguntas: FormArray = this.form.get('preguntas') as FormArray;
    const preguntas = this.preguntasArray;
    const respuestas = preguntas.controls[i] as FormArray;
    const respuesta = respuestas.controls[0];
    const tipo = this.preguntas[i].respuestas[j].tipo;

    /*console.log('preguntas.controls');
    console.log(preguntas.controls);
    console.log('preguntas.controls');*/

    /*this.preguntas[i].respuestas.forEach((respuestaH, index) => {
      const tipoHelper = respuestaH.tipo;
      console.log('respuesta');
      console.log(respuestaH);
      console.log('respuesta');
      if (tipoHelper === 'text'){
        respuesta.get('texto').clearValidators();
      }
      if (tipoHelper === 'integer'){
        respuesta.get('texto').clearValidators();
      }
      respuesta.get('texto').updateValueAndValidity();
    });*/

    respuesta.get('texto').clearValidators();


    if (e.source.checked){
      /*console.log('tipo');
      console.log(tipo);
      console.log('tipo');*/
      if (tipo === 'text'){
        respuesta.get('texto').setValidators([Validators.required]);
      }
      if (tipo === 'integer'){
        respuesta.get('texto').setValidators([Validators.required]);
      }
      respuesta.get('texto').updateValueAndValidity();
    }else{
      if (tipo === 'text'){
        respuesta.get('texto').clearValidators();
      }
      if (tipo === 'integer'){
        respuesta.get('texto').clearValidators();
      }
      respuesta.get('texto').updateValueAndValidity();
    }
    //console.log(respuesta);
    this.cotejaForm();
  }

  cotejaForm(): void{
    const preguntas = this.preguntas;
    let falta = false;
    // console.log(this.form.value);
    // this.formValid = true;

    /*
    const preguntas = this.preguntasArray;
    console.log(preguntas.controls[i]);
    const respuestas = preguntas.controls[i] as FormArray;
    const respuesta = respuestas.controls[0];
    const tipo = this.preguntas[i].respuestas[j].tipo;
    */


    //const preguntasForm: FormArray = this.form.get('preguntas') as FormArray;
    const preguntasForm = this.preguntasArray;
    preguntas.forEach((pregunta, key) => {
      if(pregunta.obligatoria){
        // console.log('Obligatorio');
        const respuestas = preguntasForm.controls[key] as FormArray;
        respuestas.controls.forEach((respuesta, keyb) => {
          if (respuesta.get('valor').value == null){
            falta = true;
          }
        });
      }else{
        // console.log('No obligatorio');
      }
    });

    // this.formValid = falta;

    if (falta){
      // console.log('Le faltan');
      this.formEncuestasValid = false;
    }else{
      // console.log('No faltan');
      this.formEncuestasValid = true;
    }/**/
  }



  saveEncuesta(){
    //console.log(this.formEncuesta.value);
    this.solicitudesService.saveEncuestaPresolicitud(this.formEncuesta.value).subscribe(response => {
      if(response.status){
        this.encuestaRespondida = true;
        this.alertDialog('Respuestas registradas', response.message, 'Cerrar');
      }else{
        this.alertDialog('Error', response.message, 'Cerrar');
      }
    }, error => {
        console.log(error);
        this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });
  }


   /*
   updateApoyosDisponiblesList(){
    this.apoyos_disponibles_list = [];
    this.apoyos_disponibles.forEach(apoyo => {
      const apoyo_code = apoyo.ejercicio+'_'+apoyo.id_programa+'_'+apoyo.id_subprograma+'_'+apoyo.id_componente+'_'+apoyo.id_beneficio+'_'+apoyo.id_concepto_apoyo;
      if(this.apoyos_agregado_helper.includes(apoyo_code)){
        if(this.subprogramaMultiApoyo){
          this.apoyos_disponibles_list.push(apoyo);
        }
      }else{
        this.apoyos_disponibles_list.push(apoyo);
      }
    });
  }
   */


}

interface marker {
  lat: number;
  lng: number;
  draggable: boolean;
  }
